module.exports = __webpack_public_path__ + "img/expired-sub.940f06e2.png";